import { allergyIntoleranceDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/allergy-intolerance-drawer-action';
import { binaryDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/binary-drawer-action';
import { claimDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/claim-drawer-action';
import { conditionDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/condition-drawer-action';
import { diagnosticReportDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/diagnostic-report-drawer-action';
import { documentReferenceDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/document-reference-drawer-action';
import { encounterDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/encounter-drawer-action';
import { episodeOfCareDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/episode-of-care-drawer-action';
import { immunizationDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/immunization-drawer-action';
import { measureReportDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/measure-report-drawer-action';
import { medicationStatementDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/medication-statement-drawer-action';
import { observationDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/observation-drawer-action';
import { practitionerDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/practitioner-drawer-action';
import { serviceRequestDrawerAction } from '@ctw/shared/context/_internal/resource/resource-actions/resource-drawer-actions/service-request-drawer-action';
import type { UseResourceDrawerOpenDrawerArgs } from '@ctw/shared/context/resource-drawer-context';
import type {
  FetchableModelType,
  FetchableResourceType,
} from '@ctw/shared/utils/fhir/resource-mappings';

const resourceTypeDrawerActionMap: {
  [TResourceType in FetchableResourceType]: TResourceType extends FetchableResourceType
    ? UseResourceDrawerOpenDrawerArgs<TResourceType>['action']
    : undefined;
} = {
  Claim: claimDrawerAction,
  Condition: conditionDrawerAction,
  MeasureReport: measureReportDrawerAction,
  EpisodeOfCare: episodeOfCareDrawerAction,
  Encounter: encounterDrawerAction,
  MedicationStatement: medicationStatementDrawerAction,
  DiagnosticReport: diagnosticReportDrawerAction,
  Observation: observationDrawerAction,
  AllergyIntolerance: allergyIntoleranceDrawerAction,
  Immunization: immunizationDrawerAction,
  ServiceRequest: serviceRequestDrawerAction,
  Practitioner: practitionerDrawerAction,
  DocumentReference: documentReferenceDrawerAction,
  Binary: binaryDrawerAction,
} as const;

export const resourceDrawerActionForModel = <
  TResourceType extends FetchableResourceType = FetchableResourceType,
  TModel extends FetchableModelType<TResourceType> = FetchableModelType<TResourceType>,
>(
  model: TModel,
) => resourceTypeDrawerActionMap[model.resourceType as keyof typeof resourceTypeDrawerActionMap];
